export function TypingIndicator({ statusMessage }: { statusMessage?: string | null }) {
  return (
    <div className="flex items-end gap-2 justify-start">
      <div className="bg-zinc-800 rounded-2xl px-4 py-3 flex items-center gap-1.5">
        {statusMessage ? (
          <span className="text-xs text-zinc-400 italic">{statusMessage}</span>
        ) : (
          <>
            <span className="w-2 h-2 bg-zinc-500 rounded-full animate-bounce [animation-delay:0ms]" />
            <span className="w-2 h-2 bg-zinc-500 rounded-full animate-bounce [animation-delay:150ms]" />
            <span className="w-2 h-2 bg-zinc-500 rounded-full animate-bounce [animation-delay:300ms]" />
          </>
        )}
      </div>
    </div>
  );
}
